import { render, staticRenderFns } from "./BreadcrumbsApp.vue?vue&type=template&id=32731357"
import script from "./BreadcrumbsApp.vue?vue&type=script&lang=js"
export * from "./BreadcrumbsApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports